module.exports = __webpack_public_path__ + "static/img/login.a730a748.png";